import React from 'react';
// Table: Word dokumanindaki veri sorumlusu / cerez turleri / basvuru tablolari icin
import { Container, Row, Col, Table } from 'react-bootstrap';
import {
    FaCookie, FaShieldAlt, FaCogs, FaChartLine, FaUserCheck, FaInfoCircle,
    FaBuilding, FaListAlt, FaBullseye, FaShareAlt, FaEnvelopeOpenText
} from 'react-icons/fa';

const CookiePolicy = () => {
    return (
        <div className="cookie-policy-page">
            {/* Header Section */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <div className="d-flex justify-content-center align-items-center mb-4">
                            <FaCookie className="me-3" style={{ fontSize: '3rem', color: 'var(--black)' }} />
                            <h1 className="section-title mb-0">Çerez Politikası ve Aydınlatma Metni</h1>
                        </div>
                        <p className="lead">Prime Motorlu Araçlar Anonim Şirketi çerez kullanım politikası ve kullanıcı hakları hakkında bilgilendirme</p>
                    </div>
                </Container>
            </section>

            {/* Content Section */}
            <section className="py-5 bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>

                            {/* 1 - Amaç ve Kapsam */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaInfoCircle />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Amaç ve Kapsam</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Prime Motorlu Araçlar Anonim Şirketi (“Şirket”) olarak web sitemiz aracılığıyla elde ettiğimiz ve
                                            işlediğimiz kişisel verilerinizin korunmasını öncelikli bir yükümlülük olarak benimsemekteyiz.
                                            Bu kapsamda, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca hazırlanan işbu
                                            Aydınlatma Metni ile web sitemizin işletimi sırasında ve ziyaretleriniz esnasında kullanılan çerezler
                                            vasıtasıyla elde edilen kişisel verileriniz hakkında tarafınızı bilgilendirmeyi amaçlamaktayız.
                                        </p>
                                        <p className="modern-faq-answer mb-3">
                                            Şirket, KVKK kapsamında veri sorumlusu sıfatıyla, web sitesinde hangi tür çerezlerin hangi amaçlarla
                                            kullanıldığını ve bu çerezlerin nasıl yönetilebileceğini açıklamakla yükümlüdür.
                                        </p>
                                        <p className="modern-faq-answer">
                                            İşbu Politika'da zaman zaman değişiklik yapılabilecektir. Güncellemeler, web sitemizde yayımlandığı
                                            tarih itibarıyla yürürlüğe girer. Yürürlükteki versiyonu takip edebilmek için Politika'nın başında
                                            yer alan tarihi düzenli olarak kontrol etmenizi tavsiye ederiz.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 2 - Veri Sorumlusu */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaBuilding />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Veri Sorumlusu</h3>
                                        {/* Adres / e-posta / KEP: firma tarafindan doldurulacak */}
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Veri Sorumlusu</strong></td>
                                                    <td>Prime Motorlu Araçlar Anonim Şirketi</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Adres</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>E-posta</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>KEP</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 3 - Toplanma Yöntemi ve Hukuki Dayanaklar */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaCogs />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Kişisel Verilerin Toplanma Yöntemi ve Hukuki Dayanaklar</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verileriniz, aşağıda belirtilen çerez türleri ve bunlara ileride eklenebilecek diğer kanallar
                                            vasıtasıyla otomatik ya da otomatik olmayan yollarla, sözlü, yazılı veya elektronik ortamda
                                            toplanmaktadır.
                                        </p>

                                        {/* Kullanim amacina gore cerez turleri */}
                                        <h6 className="advantage-title-modern mt-4">Kullanım Amacına Göre Çerez Türleri</h6>
                                        <Table responsive bordered className="modern-faq-answer mb-4">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Zorunlu Çerezler</strong></td>
                                                    <td>Web sitesinin teknik işlevselliğini sağlamak için zorunludur. Veri işleme KVKK m.5/2 kapsamında hizmetin ifasına dayanmaktadır.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Analitik Çerezler</strong></td>
                                                    <td>Ziyaret ve kullanım davranışlarını ölçer. Veriler anonimleştirilerek işlenir ve pazarlama etkinliği analizinde kullanılır.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Hedefleme, Reklam ve Pazarlama Çerezleri</strong></td>
                                                    <td>Kişiselleştirilmiş içerik ve reklam sunulmasını sağlar. Açık rızaya dayanır.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>İşlevsellik Çerezleri</strong></td>
                                                    <td>Kullanılabilirliği ve kullanıcı deneyimini artırır. Anonim veya kullanıcı tercihlerine ilişkin veri işleyebilir.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Kişiselleştirme Çerezleri</strong></td>
                                                    <td>Kullanıcı tercihlerini, dil seçimlerini ve ayarları hatırlar.</td>
                                                </tr>
                                            </tbody>
                                        </Table>

                                        {/* Suresine gore cerez turleri */}
                                        <h6 className="advantage-title-modern">Süresine Göre Çerez Türleri</h6>
                                        <Table responsive bordered className="modern-faq-answer mb-4">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Oturum Çerezleri</strong></td>
                                                    <td>Tarayıcı kapatıldığında silinir. Oturum süresince güvenli ve kesintisiz kullanım sağlar.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Kalıcı Çerezler</strong></td>
                                                    <td>Cihazda belirli süre saklanır. Tercihleri hatırlar ve bazı durumlarda özelleştirilmiş içerik sunar.</td>
                                                </tr>
                                            </tbody>
                                        </Table>

                                        {/* Taraflarina gore cerez turleri */}
                                        <h6 className="advantage-title-modern">Taraflarına Göre Çerez Türleri</h6>
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Birinci Taraf Çerezler</strong></td>
                                                    <td>Doğrudan web sitesi veya Şirket tarafından yerleştirilir.</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Üçüncü Taraf Çerezler</strong></td>
                                                    <td>Reklam verenler ve analitik hizmet sağlayıcılar gibi üçüncü taraflarca yerleştirilir.</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 4 - Kullanılmakta Olan Çerezler */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaListAlt />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Kullanılmakta Olan Çerezler</h3>
                                        {/* Cerez adi / amac / islenen veri: firma tarafindan doldurulacak */}
                                        <Table responsive bordered className="modern-faq-answer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Çerez Adı</th>
                                                    <th>Çerez Türü</th>
                                                    <th>Amaç</th>
                                                    <th>Saklama Süresi</th>
                                                    <th>İşlenen Kişisel Veri</th>
                                                    <th>Aktarım Durumu</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>[●]</td>
                                                    <td>Birinci taraf kalıcı çerez</td>
                                                    <td>[●]</td>
                                                    <td>1 yıl</td>
                                                    <td>[●]</td>
                                                    <td>Başka veri sorumlularına aktarılmaktadır.</td>
                                                </tr>
                                                <tr>
                                                    <td>[●]</td>
                                                    <td>Oturum çerezi</td>
                                                    <td>[●]</td>
                                                    <td>Yalnızca oturum süresince geçerli olup tarayıcı kapatıldığında otomatik olarak silinir</td>
                                                    <td>[●]</td>
                                                    <td>Başka veri sorumlularına aktarılmamaktadır.</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            {/* 5 - Çerez ve İşaret Teknolojilerinin Kullanımı */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaBullseye />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Çerez ve İşaret Teknolojilerinin Kullanımı</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Web sitemizi ziyaretleriniz sırasında kullanıcı deneyimini geliştirmek amacıyla çerezler, piksel
                                            etiketleri ve gif dosyaları gibi çeşitli teknolojilerden (“Çerezler”) yararlanılmaktadır. Bu
                                            teknolojilerin kullanımı, başta KVKK olmak üzere tabi olunan mevzuata uygun biçimde
                                            gerçekleştirilmektedir.
                                        </p>
                                        <p className="modern-faq-answer">
                                            Bazı üçüncü taraflarla birlikte, piksel etiketleri veya işaretler adıyla bilinen ve cihazınızdan
                                            sunucuya bilgi aktaran teknolojiler de kullanılabilmektedir. Bu teknolojiler, çevrimiçi içerik, video
                                            ve e-postalara yerleştirilebilmekte ve ilgili içeriğin görüntülendiği tarih, saat ile cihazınızın IP
                                            adresinin tespit edilmesine imkân tanımaktadır. Söz konusu teknolojiler, hizmetlerin kullanım
                                            analizinin yapılması ve kullanıcıya ilgili içerik ile reklamların sunulması gibi amaçlarla
                                            kullanılmaktadır.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 6 - Kişisel Verilerin İşlenme Amaçları */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaChartLine />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Kişisel Verilerin İşlenme Amaçları</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verileriniz, KVKK'nın 5. maddesinin 2. fıkrasında belirtilen veri işleme şartları çerçevesinde
                                            aşağıdaki amaçlarla işlenmekte ve saklanmaktadır:
                                        </p>
                                        <p className="modern-faq-answer">
                                            Web sitemize her erişimde internet tarayıcınız aracılığıyla otomatik olarak sunucumuza iletilen teknik
                                            veriler (<em>erişim tarihi ve saati, yönlendiren web sitesinin URL bilgisi, erişilen dosyalar, aktarılan
                                            veri miktarı, tarayıcı türü ve sürümü, işletim sistemi, IP adresi ve benzeri bilgiler</em>) bu kapsamda
                                            işlenmektedir. Bunların yanı sıra web sitemizin işlevselliğinin sağlanması ile sistem hatalarının
                                            giderilmesi ve güvenlik olaylarının aydınlatılması da veri işleme amaçları arasında yer almaktadır.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 7 - Üçüncü Kişilere ve Yurt Dışına Aktarım */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaShareAlt />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Kişisel Verilerin Üçüncü Kişilere ve Yurt Dışına Aktarılması</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verileriniz, işbu Aydınlatma Metni'nin “Kişisel Verilerinizin İşlenme Amaçları” bölümünde
                                            belirtilen amaçlar doğrultusunda ve KVKK'nın 8. ve 9. maddeleri kapsamında gerekli teknik tedbirler
                                            alınmak kaydıyla aşağıdaki taraflarla paylaşılabilecektir:
                                        </p>
                                        <div className="ms-4">
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Bilgi güvenliği süreçlerinin yürütülmesi amacıyla depolama, arşivleme ve bulut bilişim gibi
                                                        alanlarda hizmet aldığımız üçüncü kişiler,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        İş faaliyetlerinin yürütülmesi kapsamında çalışılan iş ortakları, analitik hizmet
                                                        sağlayıcıları, işbirliği ilişkisi kurulan taraflar ve
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        İlgili mevzuat uyarınca talep halinde yetkili idari ve adli merciler.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 8 - Çerez Tercihlerinin Yönetilmesi */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaShieldAlt />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Çerez Tercihlerinin Yönetilmesi</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Web tarayıcınızı, tüm çerezleri kabul edecek, tamamını reddedecek veya bir çerez gönderildiğinde sizi
                                            bilgilendirecek biçimde yapılandırabilirsiniz. Çerez tercihlerinizi nasıl yönetebileceğinizi öğrenmek
                                            için tarayıcınızın yardım menüsünü incelemenizi öneririz. Her tarayıcının bu konudaki işleyişi
                                            farklılık gösterebilmektedir. Ayrıca cihazınızın işletim sistemi ek çerez yönetim seçenekleri
                                            sunabilmektedir.
                                        </p>
                                        <p className="modern-faq-answer">
                                            Bazı hizmetlerin çerez kullanımına dayalı olarak tasarlandığını ve çerezlerin devre dışı bırakılmasının
                                            ilgili hizmetlerin tamamına veya bir bölümüne erişim imkânınızı etkileyebileceğini hatırlatmak isteriz.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 9 - İlgili Kişi Hakları */}
                            <div className="modern-faq-item mb-4">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaUserCheck />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Kişisel Verisi İşlenen İlgili Kişi Hakları</h3>
                                        <p className="modern-faq-answer mb-3">
                                            Kişisel verisi işlenen İlgili Kişinin KVKK 11. maddesi kapsamında koruma altına alınan ve aşağıda
                                            sayılan hakları bulunmaktadır:
                                        </p>
                                        <div className="ms-4">
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Kişisel Verilerin işlenip işlenmediğini öğrenme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Kişisel Veriler işlenmişse buna ilişkin bilgi talep etme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Kişisel Verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Yurt içinde veya yurt dışında Kişisel Verilerin aktarıldığı üçüncü kişileri bilme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Kişisel Verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Mevzuatta öngörülen şartlar çerçevesinde Kişisel Verilerin silinmesini veya yok edilmesini isteme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Eksik veya yanlış verilerin düzeltilmesi ile Kişisel Verilerin silinmesi veya yok edilmesini
                                                        talep edildiğinde, bu durumun Kişisel Verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card mb-2">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
                                                        aleyhinize bir sonucun ortaya çıkmasına itiraz etme ve
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="modern-advantage-card">
                                                <div className="advantage-content">
                                                    <p className="advantage-description-modern mb-0">
                                                        Kişisel Verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğranması halinde bu
                                                        zararın giderilmesini talep etme.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 10 - Başvuru Yöntemleri */}
                            <div className="modern-faq-item">
                                <div className="d-flex align-items-start">
                                    <div className="advantage-icon-modern me-3">
                                        <FaEnvelopeOpenText />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h3 className="modern-faq-question">Hakların Kullanımına Yönelik Başvuru Yöntemleri</h3>
                                        <p className="modern-faq-answer mb-3">
                                            İşbu Aydınlatma Metni’nin “Kişisel Verisi İşlenen İlgili Kişi Hakları” başlıklı 6. maddesinde ifade
                                            edilen hakların KVKK 13. maddesine ve Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ’e uygun
                                            olarak kullanılması gerekmektedir. Başvuru yönteminize göre aşağıda yer alan posta, elektronik posta
                                            veya kayıtlı elektronik posta (KEP) adreslerine gönderebilirsiniz. Başvuru Formu’nun gönderilmesi
                                            sırasında zarf üzerine veya gönderilecek e-postanın konu kısmına “Kişisel Verilerin Korunması Kanunu
                                            Kapsamında Bilgi Talebi” yazılması gerekmektedir.
                                        </p>
                                        {/* Adres / KEP / e-posta: firma tarafindan doldurulacak */}
                                        <Table responsive bordered className="modern-faq-answer mb-3">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}><strong>Yazılı başvuru ile</strong></td>
                                                    <td>
                                                        Kimliğinizi doğrulamak kaydıyla Şirketimize iletebilir veya noter aracılığıyla
                                                        gönderebilirsiniz. [●]
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>KEP ile</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>E-posta ile</strong></td>
                                                    <td>[●]</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <p className="modern-faq-answer mb-0">
                                            Başvurular mümkün olan en kısa sürede ve talebin niteliğine göre talebin Şirket’e ulaştığı tarihten
                                            itibaren en geç 30 gün içerisinde yanıtlandırılır.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default CookiePolicy;